<app-dialog-layout (cancel)="handleCancel()">
  <div dialog-title>
    <span class="d-inline-block bg-primary-lighter p-2 radius-2">
      <span class="d-inline-block bg-primary-light p-1 radius-1 text-primary">
        <app-icon name="calendar"></app-icon>
      </span>
    </span>
  </div>

  <app-state-section [state]="sectionState">
    <h5 class="mb-0 pt-3 text-900">{{'sharedFeatures.EditGateToGate.EditTime' | translate}}</h5>
    <div class="mt-0 mb-3 text-500">{{'sharedFeatures.EditGateToGate.ConfirmEdit' | translate}}</div>

    <app-row [formGroup]="form" class="pb-6">
      <app-col cols="12">
        <app-date-input [title]="'sharedFeatures.EditGateToGate.AccurateTime' | translate" formControlName="date"></app-date-input>
      </app-col>

      <app-col cols="12">
        <app-time-field formControlName="time"></app-time-field>
      </app-col>
    </app-row>
  </app-state-section>

  <div dialog-action class="w-100">
    <app-row>
      <app-col cols="12" sm="6">
        <button mat-stroked-button class="d-block w-100 brd-primary-light mb-2 mb-sm-0" color="primary" type="button" (click)="handleCancel()">
          {{'shared.Buttons.Cancel' | translate}}
        </button>
      </app-col>

      <app-col cols="12" sm="6">
        <button
          mat-flat-button
          class="d-block w-100"
          color="primary"
          type="button"
          [disabled]="sectionState !== SectionStateStatus.Ready"
          (click)="handleConfirm()"
        >
          {{'shared.Buttons.Submit' | translate}}
        </button>
      </app-col>
    </app-row>
  </div>
</app-dialog-layout>
